import axios from 'axios'
import appConfig from '@/service/config'
import userService from '@/service/userService'

function unBlockDays(params) {
    return axios({
        method: 'post',
        url: appConfig.baseUrl + '/schedule/unBlock',
        data: {...params, ...{ storeId: userService.getCurrentStore() } },
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
}

function blockDays(params) {
    return axios({
        method: 'post',
        url: appConfig.baseUrl + '/schedule/block',
        data: {...params, ...{ storeId: userService.getCurrentStore() } },
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
}

function fetchDays(params) {
    return axios({
        method: 'post',
        url: appConfig.baseUrl + '/schedule/fetchDays',
        data: {...params, ...{ storeId: userService.getCurrentStore() } },
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
}

function fetchStats(params) {
  return axios({
      method: 'post',
      url: appConfig.baseUrl + '/schedule/fetchStats',
      data: {...params, ...{ storeId: userService.getCurrentStore() } },
      headers: {
        Authorization: userService.getAuthHeader()
      }
    })
}

function addDayInfo(params) {
    const data = {
        storeId: userService.getCurrentStore(),
        data: params
    }
    return axios({
        method: 'post',
        url: appConfig.baseUrl + '/schedule/addDayInfo',
        data: data,
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
}

function deleteDayInfo(dayInfoId) {
    return axios({
        method: 'post',
        url: appConfig.baseUrl + '/schedule/deleteDayInfo',
        data: {
            dayInfoId: dayInfoId
        },
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
}

function updateDayInfo(params) {
    return axios({
        method: 'post',
        url: appConfig.baseUrl + '/schedule/updateDayInfo',
        data: params,
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
}

function getUsers() {
    return axios({
        method: 'get',
        url: appConfig.baseUrl + '/users',
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
}

export default {
    "getUsers": getUsers,
    "deleteDayInfo": deleteDayInfo,
    "fetchDays": fetchDays,
    "fetchStats": fetchStats,
    "addDayInfo": addDayInfo,
    "updateDayInfo": updateDayInfo,
    "blockDays": blockDays,
    "unBlockDays": unBlockDays
}



// WEBPACK FOOTER //
// ./src/components/schedule/ScheduleRestClient.js